import React from "react";

export default ({loaderColor}) => (
  <div className="spinner">
    <div className="bounce1" style={loaderColor ? { backgroundColor: loaderColor } : {}}></div>
    <div className="bounce2" style={loaderColor ? { backgroundColor: loaderColor } : {}}></div>
    <div className="bounce3" style={loaderColor ? { backgroundColor: loaderColor } : {}}></div>
  </div>
);
